import { OrganizationScope } from "~/hooks/useScope";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { Home as HomeIcon } from "@mui/icons-material";
import { PolicyDetailPage } from "~/pages/shared/policy/PolicyDetailPage";

export interface OrganizationPolicyDetailPageProps {
  scope: OrganizationScope;
}

export function OrganizationPolicyDetailPage({
  scope,
}: OrganizationPolicyDetailPageProps) {
  return (
    <PolicyDetailPage
      scope={scope}
      basePath="/organization/policies"
      defaultTitle="Organization Policy Detail"
      renderBreadcrumbs={(title) => (
        <Breadcrumbs sx={{ mb: 3, overflowWrap: "anywhere" }} separator="›">
          <Link
            key="/dashboard"
            component={RouterLink}
            to={`/dashboard`}
            display="flex"
          >
            <HomeIcon fontSize="inherit" />
          </Link>
          <Link
            key="/organization/policies"
            component={RouterLink}
            to={`/organization/policies?${scope.params}`}
          >
            Organization Policies
          </Link>
          <Typography key="/organization/policies/:policyId">
            {title}
          </Typography>
        </Breadcrumbs>
      )}
    />
  );
}
